<div
  tabindex="0"
  class="flex flex-col rounded-2xl font-title px-5 py-4 border border-gray-200 w-full text-left bg-white"
>
  <div class="flex items-center justify-between gap-2 w-full">

    <!-- Estat + Mode -->
    <div class="flex items-center gap-2 min-w-0">

      <lib-icon [name]="iconStateName()" />

      <div class="flex flex-col min-w-0 text-sm gap-1">

        <!-- Estat -->
          <span class="font-semibold text-gray-800 overflow-hidden line-clamp-2 leading-5">
          {{ sectorStateString() }}
        </span>

        <!-- Mode -->
        <span class="text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap">
          {{ sectorModeString() }}
        </span>

      </div>

    </div>


    <!-- Dotació superada -->
     @if (sector()?.state === SectorState.IRRIGATION_ALLOCATION) {

       <div class="flex flex-col items-end">
         
         <lib-badge
         color="warning"
         variant="light"
         size="xs"
         startIcon="long-arrow-up">
         Dot. superada
        </lib-badge>
      </div>
    }

  </div>

  @if(sector().stateReason !== SectorStateReason.NONE){
    <lib-sector-state-reason-badge [sector]="sector()" class="mt-2"></lib-sector-state-reason-badge>
  }

  @if(sector().schedulingPerson){
    <div
      class="mt-2 w-fit flex items-center gap-1 px-2.5 py-1 rounded-full text-gray-700 text-xs font-title font-medium"
      [class.bg-brand-50]="sector().schedulingPersonType === 'OWNER'"
      [class.bg-gray-100]="sector().schedulingPersonType !== 'OWNER'">
      <lib-icon [name]="schedulingPersonIcon()" class="size-4 flex-shrink-0 overflow-hidden [&>span]:!size-4"></lib-icon>
      <span class="truncate">{{ sector().schedulingPerson }}</span>
    </div>
  }
</div>
